// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-rightsholder-form h5,
.register-rightsholder-form p {
  display: flex;
  align-items: center;
}
.register-rightsholder-form h5 .custom-tool-tip .info-label,
.register-rightsholder-form p .custom-tool-tip .info-label {
  margin-left: 0.6rem;
}
.register-rightsholder-form h5 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.register-rightsholder-form .mailing-address-wrapper .mailing-address {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.register-rightsholder-form .phone-number-form-component {
  padding-top: 1rem;
}
.register-rightsholder-form .terms-and-conditions {
  padding-top: 1.5rem;
}
.register-rightsholder-form .button-component {
  padding-top: 5rem;
  padding-bottom: 5rem;
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/index.scss"],"names":[],"mappings":"AACE;;EAEE,aAAA;EACA,mBAAA;AAAJ;AAGM;;EACE,mBAAA;AAAR;AAKE;EACE,iBAAA;EACA,oBAAA;AAHJ;AAOI;EACE,iBAAA;EACA,oBAAA;AALN;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,iBAAA;EACA,oBAAA;EACA,YAAA;AATJ","sourcesContent":[".register-rightsholder-form {\n  h5,\n  p {\n    display: flex;\n    align-items: center;\n\n    .custom-tool-tip {\n      .info-label {\n        margin-left: 0.6rem;\n      }\n    }\n  }\n\n  h5 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .mailing-address-wrapper {\n    .mailing-address {\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n    }\n  }\n\n  .phone-number-form-component {\n    padding-top: 1rem;\n  }\n\n  .terms-and-conditions {\n    padding-top: 1.5rem;\n  }\n\n  .button-component {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n    float: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
